import { Group, Burger, Text, ActionIcon, Menu } from '@mantine/core';
import { IconLogout, IconUser, IconSettings } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import { CompanySelector } from './CompanySelector';
import { useAuth } from '../../hooks/useAuth';

interface HeaderProps {
  opened: boolean;
  toggle: () => void;
}

export function Header({ opened, toggle }: HeaderProps) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <Group h="100%" px="md" justify="space-between">
      <Group>
        <Burger opened={opened} onClick={toggle} hiddenFrom="sm" size="sm" />
        <Text fw={700} size="lg">AI-Department</Text>
      </Group>

      <Group>
        <CompanySelector />

        <Menu shadow="md" width={200}>
          <Menu.Target>
            <ActionIcon variant="subtle" size="lg">
              <IconUser size={20} />
            </ActionIcon>
          </Menu.Target>

          <Menu.Dropdown>
            <Menu.Label>{user?.fullName}</Menu.Label>
            <Menu.Label c="dimmed">{user?.phone}</Menu.Label>
            <Menu.Divider />
            <Menu.Item
              leftSection={<IconSettings size={14} />}
              onClick={() => navigate('/profile')}
            >
              Настройки профиля
            </Menu.Item>
            <Menu.Item
              color="red"
              leftSection={<IconLogout size={14} />}
              onClick={logout}
            >
              Выйти
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Group>
    </Group>
  );
}
